<template>
    <div>
        <div v-if="perferenceList.length !== 0">
            <el-card shadow="hover" class="preference-item" v-for="(i, idx) in perferenceList">
                <div class="preference-item-header">
                    <div class="preference-item-time">{{i.create_time}}</div>
                    <div class="preference-item-username">{{i.username}}</div>
                </div>
                <div class="preference-card-content">{{i.content}}</div>
            </el-card>
        </div>
        <el-empty v-else description="暂无数据"></el-empty>
    </div>
</template>

<script>
import {getContactPreference} from '@/api/api'
export default {
    name: "ContractPreference",
    props: {
        contactId: {
            required: true
        },
        refreshId: {
            required: true
        }
    },
    data() {
        return {
            perferenceList: []
        }
    },

    mounted() {
        this.refresh()
    },

    watch: {
        refreshId(newVal) {
            this.refresh()
        }
    },
    
    methods: {
        async getData() {
            let postData = {
                contact_id: this.contactId,
                business: "合同"
            }
            let res = await getContactPreference(postData)
            this.perferenceList = res.respData
        },

        async refresh(){
            await this.getData()
        }
    }
}
</script>
<style lang="scss">

.preference-item{
    padding: 5px;
    margin-top: 10px;
    .preference-item-header{
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-bottom: 5px;
        color: gray;
        .preference-item-username{
            margin-left: 20px;
        }
    }
    .preference-card-content{
        font-size: 14px
    }
}


</style>